import angular from 'angular';

import { unitPopupRoutesConfig } from './unit.popup.routes';

import '../activity/Activity.directive';
import '../tasks/EntityTasks.directive';

export default angular
  .module('unit.popup', ['ui.router', 'ngResource'])
  .config(unitPopupRoutesConfig);
